// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscacidadesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaCidades() /localidades/buscaCidades
 *
 * Proxy to locations-service (Go microservice). Each row mirrors
 * `entity.City` from services/locations-service/src/localidades/city/entity/entity.go.
 */
import type { Localidades_BuscacidadesRow } from './Localidades_BuscacidadesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_BuscacidadesResponseDados = Localidades_BuscacidadesRow[];

export type Localidades_BuscacidadesResponse = ApiResponse<Localidades_BuscacidadesResponseDados>;

registerResponseContract('Localidades_BuscacidadesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:      { type: 'number',  required: false },
      Name:    { type: 'string',  required: false },
      StateID: { type: 'number',  required: false },
    },
  },
})
